<template>
    <div class="button-cell" data-field-type="automation-button">
        <a-button :disabled="isDisabled" @click="$feature.beforeRunButtonAutomation(handleClick)" type="primary">
            {{ label }}
        </a-button>
    </div>
</template>

<script>
import { sendSocketMessage } from "../../../../../utils/socketStream";
import PermissionController from "../../../../../components/permission-controller/PermissionController";
import { sessionId } from "../../../../../utils/session";
export default {
    name: "ButtonCell",
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        tableId: {
            type: String,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isDisabled: false,
        };
    },
    computed: {
        label() {
            return this.field.options.button.defaultLabel || "Button";
        },
        isClicked() {
            const value = this.record.data[this.field._id];
            return value ? value.clicked : false;
        },
    },
    watch: {
        isClicked: {
            immediate: true,
            handler(newVal) {
                if (this.field.options.button.disableWhenClicked && newVal) {
                    this.isDisabled = true;
                }
            },
        },
    },
    methods: {
        async updateCellAsClicked() {
            const value = this.record.data[this.field._id] || {};
            await this.$emit("update-record", {
                recordId: this.record._id,
                fieldId: this.field._id,
                value: {
                    ...value,
                    clicked: true,
                },
            });
        },
        handleClick() {
            if (!PermissionController.check(["table.update"])) {
                PermissionController.sendError();
                return;
            }
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            sendSocketMessage("automation run-table-button", {
                siteId: this.$store.state.site.site._id,
                tableId: this.tableId || this.record.table,
                fieldId: this.field._id,
                recordId: this.record._id,
                automationId: this.field.options.button.automation,
                userId: this.$store.state.auth.user._id,
                sessionId,
            });
            this.updateCellAsClicked();
        },
    },
};
</script>

<style scoped>
.button-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    .ant-btn {
        width: 100%;
    }
}
</style>
